export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";

export const FETCH_POSTS_START = 'FETCH_POSTS_START';
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE';
export const FETCH_ALL = "FETCH_POSTS_SUCCESS"; // Alias for compatibility if needed, ideally rename FETCH_ALL usage

export const LIKE = "LIKE";
export const OPTIMISTIC_LIKE_POST = "OPTIMISTIC_LIKE_POST";
export const LIKE_POST_FAILED = "LIKE_POST_FAILED";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
